// extracted by mini-css-extract-plugin
export var aircallIframe = "_eu-3";
export var fabContainer = "_eu-5";
export var fabRinging = "_eu-6";
export var loadingOverlay = "_eu-4";
export var pulse = "_eu-7";
export var widgetContent = "_eu-2";
export var widgetPanel = "_eu-0";
export var widgetPanelExpanded = "_eu-1";